// extracted by css-extract-rspack-plugin
export default {"cls1":"FriendlySutdModal-cls1_CZ1","cls2":"FriendlySutdModal-cls2_63f FriendlySutdModal-cls1_CZ1"};